import React from "react";
import classNames from "classnames";

import ReactTable from "react-table";
import ClipLoader from 'react-spinners/ClipLoader';

import API from "@beardeddevops/react.api";
import APPCONFIG from "../../constants/Config";
import Framework from "@beardeddevops/react.framework";
import Types from 'constants/Types';

import moment from "moment";
import {formatPaymentMethodSlugLabel} from "../../utils/paymentMethodLabel";

const EVENT_LABELS = {
	payment: "Payment",
	write_off: "Written Off",
};

class InvoicePayments extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Invoices_Payments._name, API.RequestType.READ_ALL);
		model.parent = props.parent;
		super(props, model);
		this.state.limit = 10;
		this.limit = 10;
	}

	paymentByLabel = (row) => {
		if (row.users != null) {
			return `${row.users.name_first || ''} ${row.users.name_last || ''}`.trim();
		}
		return this.props.rootState?.account_name || '-';
	};

	render() {
		const {data, pages, loading, limit} = this.state;
		const columns = [
			{
				Header: "Date",
				id: "created",
				className: 'center-column',
				accessor: obj => obj.created ? moment(obj.created).local().format("MM/DD/YYYY hh:mm A") : '-'
			},
			{
				Header: "Event",
				id: "event",
				className: 'center-column',
				accessor: r => EVENT_LABELS[r.event] ?? r.event
			},
			{
				Header: "Amount",
				id: "amount",
				className: 'center-column',
				accessor: r => "$" + parseFloat(r.amount ?? 0).toFixed(2)
			},
			{
				Header: "Method",
				id: "method",
				accessor: r => formatPaymentMethodSlugLabel(r.method) || '-'
			},
			{
				Header: "Remaining After",
				id: "remaining_after",
				className: 'center-column',
				accessor: r => r.remaining_after != null ? "$" + parseFloat(r.remaining_after).toFixed(2) : '-'
			},
			{
				Header: "By",
				id: "creator",
				className: 'center-column',
				accessor: r => this.paymentByLabel(r)
			},
			{
				Header: "Notes",
				id: "notes",
				accessor: r => r.notes
			},
		];
		return (<>
			<div className="table-bar">
				<div className="d-flex">
					{this.renderHeaderRight("InvoicePayments", columns)}
				</div>
			</div>
			<ReactTable
				key={this.state.key}
				columns={columns}
				manual
				data={data}
				pages={pages}
				loading={loading}
				loadingText="Requesting Data"
				onFetchData={this.fetchData}
				expanderDefaults={{
					sortable: true,
					resizable: true,
					filterable: false,
					width: undefined
				}}
				defaultSorted={[
					{
						id: this.model.sort,
						desc: this.model.order === 'desc'
					}
				]}
				showPagination={true}
				showPaginationTop={false}
				showPaginationBottom={true}
				showPageSizeOptions={true}
				defaultPageSize={limit}
				pageSize={limit}
				className="-striped -highlight"
			/>
			{APPCONFIG.settings.isDev() ? null :
				<div className={classNames("tabled", "loader", {'active': loading})}>
					<ClipLoader color={"#4A4A4A"} loading={loading}/>
				</div>
			}
		</>)
	}
}

export default Framework.Components.withRootState(InvoicePayments);
